<template>
  <div id="signin">
    <div class="box">
      <h1>{{ $t("Signin") }}</h1>
      <input
        class="input-box"
        v-model="email"
        type="text"
        :placeholder="$t('email')"
        :class="{ inputError: emailError }"
      />
      <span v-if="emailError">{{ $t("must be a valid email") }}</span>
      <input
        class="input-box"
        v-model="password"
        type="password"
        :placeholder="$t('password')"
        :class="{ inputError: passwordError }"
      />
      <span v-if="passwordError">{{ $t("must be a valid password") }}</span>
      <input
        class="input-submit"
        type="submit"
        @click="submit"
        :value="$t('Signin')"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import helpers from "@/mixins/helpers";
export default {
  name: "Signin",
  mixins: [helpers],
  data() {
    return {
      submitted: false,
      email: "",
      password: ""
    };
  },
  computed: {
    emailError() {
      const { submitted, email, validateEmail } = this;
      return submitted && (email == "" || !validateEmail(email)) ? true : false;
    },
    passwordError() {
      const { submitted, password } = this;
      return submitted && password == "" ? true : false;
    }
  },
  methods: {
    ...mapActions("user", ["signin"]),
    async submit() {
      this.submitted = true;
      const { emailError, passwordError, email, password, signin } = this;

      if (!emailError && !passwordError) {
        try {
          await signin({ email, password });
          if (this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect });
          }
        } catch {
          //
        }
      }
    }
  }
};
</script>

<style lang="scss">
#signin {
  margin-top: 30px;
  .box {
    max-width: 350px;
    width: 75%;
    margin: 0 auto;
    border: 1px solid #e3e3e3;
    padding: 30px;

    .input-box {
      border: 0;
      background: #fafafa;
      display: block;
      margin: 7px auto;
      text-align: left;
      border: 1px solid #efefef;
      padding: 10px;
      width: 100%;
      outline: none;
      color: #262626;
      border-radius: 4px;
      transition: 0.25s;
      font-size: 11px;
      box-sizing: border-box;
      font-weight: 400;
      text-shadow: none;
    }
    .input-submit {
      width: 100%;
      border: #e3e3e3;
      padding: 10px;
      border-radius: 5px;
    }
  }
}
</style>
